import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import api from '../../api'
import { Grid, Select, FormControl, MenuItem, Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { blackColor, hexToRgb } from "assets/jss/material-dashboard-react.js";
import LandingPage from "./upsEmsLanding";

const useStyles = makeStyles((theme) => ({
  formControl: {
    autosize: true,
    clearable: false,
  },
  select: {
    "&:after": {
      borderBottomColor: "blue",
    },
    "& .MuiSvgIcon-root": {
      color: "white",
      backgroundColor: "#0123b4",
      borderRadius: "8px",
    },
    "& .MuiSelect-root ": {
      marginTop: "-2vh",
    },
  },
}));

function GlEMLanding(props) {
  const classes = useStyles();
  const [floor, setFloor] = useState([]);
  const [fdata, setFdata] = useState(localStorage.getItem("floorName"));
  const [fid, setFId] = useState("");
  const [energydevice, setEnergydevice] = useState([]);
  const buildingID = useSelector((state) => state.isLogged.data.building.id);
  const zone_data = useSelector((state) => state.inDashboard.locationData);
  const history = useHistory();
  const PLANTROOM_ID = "2ffc9cf4-f0c6-4299-9961-921a86542bc7";

  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  useEffect(() => {
    // Guard: wait until zone_data is actually populated
    if (!zone_data || zone_data.length === 0) return;

    let zone_id = "",
      z_data = [];

    zone_data
      .slice()
      .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));

    zone_data.filter((_each) => {
      if (_each.zone_type === "GL_LOCATION_TYPE_FLOOR") {
        z_data.push(_each);
      }
    });

    // Guard: if no floor data yet, bail out
    if (z_data.length === 0) return;

    const basementZone = z_data.find(
      (z) =>
        /basement/i.test(z.name || "") ||
        /basement/i.test(z.zone_tag || "")
    );
    const plantZone = z_data.find(
      (z) =>
        z.uuid === PLANTROOM_ID ||
        /plantroom|plant/i.test(z.name || "") ||
        /plantroom|plant/i.test(z.zone_tag || "")
    );
    const defaultZone = basementZone || plantZone;

    if (defaultZone) {
      zone_id = defaultZone.uuid;
      setFdata(defaultZone.name);
      setFId(defaultZone.id || defaultZone.uuid);
    } else {
      zone_id = z_data[0].uuid;
      setFdata(z_data[0].name);
      setFId(z_data[0].id);
    }

    api.floor.devicemap(zone_id, "energyMeter").then((res) => {
      res.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
      setEnergydevice(res);
    });

    api.dashboard.getMetricData(buildingID).then((res) => {
      res.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));

      const plantFloor = res.find(
        (fl) =>
          fl.uuid === PLANTROOM_ID ||
          /plantroom|plant/i.test(fl.name || "") ||
          /plantroom|plant/i.test(fl.zone_tag || "")
      );

      if (plantFloor) {
        setFloor([plantFloor]);
        setFdata(plantFloor.name);
        setFId(plantFloor.id || plantFloor.uuid);

        api.floor
          .devicemap(plantFloor.uuid || plantFloor.id, "energyMeter")
          .then((r) => {
            r.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
            setEnergydevice(r);
          }).catch((err) => console.log("Error fetching energy meter data for plant floor:", err));
      } else {
        setFloor(res);

        const basementFloor = res.find(
          (fl) =>
            /basement/i.test(fl.name || "") ||
            /basement/i.test(fl.zone_tag || "")
        );

        if (basementFloor) {
          setFdata(basementFloor.name);
          setFId(basementFloor.id || basementFloor.uuid);

          api.floor
            .devicemap(basementFloor.uuid || basementFloor.id, "energyMeter")
            .then((r) => {
              r.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
              setEnergydevice(r);
            }).catch((err) => console.log("Error fetching energy meter data for basement floor:", err));
        }
      }
    });

  }, [buildingID, zone_data]); // ← ADD zone_data here

  useEffect(() => {
    if (!fid) return;
    const timer = setInterval(() => {
      console.log("Fetching energy meter data for floor ID:", fid);
      api.floor.devicemap(fid, "energyMeter").then((res) => {
        res.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
        setEnergydevice(res);
      }).catch((res) => console.log("Error fetching energy meter data:", res));
    }, 5000);
    return () => clearInterval(timer);
  }, [fid])


  const handlefloorchange = (name, id) => {
    setFId(id);
    setFdata(name);
    api.floor.devicemap(id, "energyMeter").then((res) => {
      res.sort(function (a, b) {
        return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
      });
      // console.log("ressssssssfrom devicemap",res)
      setEnergydevice(res);
    });
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={1}>
        <Grid container item xs={12} spacing={2}>
          <Grid item xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}>
            <FormControl
              variant="filled"
              size="large"
              className={classes.formControl}
              style={{
                width: "max-content",
                minWidth: "100%",
                backgroundColor: "#eeeef5",
                fontFamily: "Arial",
              }}
            >
              <Select
                labelId="filled-hidden-label-small"
                id="demo-simple-select-outlined"
                label="Floor"
                value={fdata || ""}
                style={{
                  fontWeight: "bold",
                  height: "6vh",
                  borderRadius: "0.8vw",
                  fontFamily: "Arial",
                }}
                disableUnderline
              >
                {floor.map((_item) => (
                  <MenuItem
                    key={_item.name}
                    value={_item.name}
                    onClick={() => handlefloorchange(_item.name, _item.id)}
                  >
                    {_item.name}

                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={2}
            lg={2}
            xl={2}
            xxl={2}
            style={{ display: "flex", alignItems: "center" }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() =>
                history.push({
                  pathname: "/admin/GlEnergyMeterSummary",
                  state: { fid, fdata },
                })
              }
              style={{
                marginLeft: "1vh",
                height: "6vh",
                borderRadius: "0.8vw",
                textTransform: "none",
              }}
            >
              Summary View
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <LandingPage device={energydevice} fid={fid} fdata={fdata} type="EMS" />
    </div>
  );
}

export default GlEMLanding




